import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { DelaisReglementairesRepository } from '../../../../store/delais-reglementaires-state/delais-reglementaires-state.repository';
import { DelaisReglementaires } from '@/types';

interface getDelaisReglementairesDataTableStructureProps {
  store: DelaisReglementairesRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getDelaisReglementairesDataTableStructure = ({
  store,
  createAction,
  rowActions,
  serverQuery,
}: getDelaisReglementairesDataTableStructureProps): DynamicDataTable => {
  const typeMarcherColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.delaisReglementaires.table.typeMarcher',
    accessorKey: 'id.typeMarcher.description',
    variant: DataTableColumnVariant.TEXT,
  };
  const modePassationColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.delaisReglementaires.table.modePassation',
    accessorKey: 'id.modePassation.libelle',
    variant: DataTableColumnVariant.TEXT,
  };
  const delaiPublicationLancementColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.delaisReglementaires.table.delaiPublicationLancement',
    accessorKey: 'delaiPublicationLancement',
    variant: DataTableColumnVariant.TEXT,
  };
  const delaiLancementAttributionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.delaisReglementaires.table.delaiLancementAttribution',
    accessorKey: 'delaiLancementAttribution',
    variant: DataTableColumnVariant.TEXT,
  };
  const delaiAttributionDemarrageColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.delaisReglementaires.table.delaiAttributionDemarrage',
    accessorKey: 'delaiAttributionDemarrage',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.delaisReglementaires.table.singular',
    plural: 'settings.delaisReglementaires.table.plural',
    columns: [
      typeMarcherColumn,
      modePassationColumn,
      delaiPublicationLancementColumn,
      delaiLancementAttributionColumn,
      delaiAttributionDemarrageColumn,
    ],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: DelaisReglementaires) => {
      store.set('dto', {
        typeMarcherId: row.id.typeMarcher.id,
        modePassationId: row.id.modePassation.id,
        delaiPublicationLancement: row.delaiPublicationLancement,
        delaiLancementAttribution: row.delaiLancementAttribution,
        delaiAttributionDemarrage: row.delaiAttributionDemarrage,
      });
      store.set('response', row);
      store.set('typeMarcherSelected', { name: row.id.typeMarcher.description, code: row.id.typeMarcher.id });
      store.set('modePassationSelected', { name: row.id.modePassation.libelle, code: row.id.modePassation.id });
    },
    createAction,
    rowActions,
    enableServerActions: true,
    serverQuery,
    searchableFields: [
      'id.typeMarcher.description',
      'id.modePassation.libelle',
      'delaiPublicationLancement',
      'delaiLancementAttribution',
      'delaiAttributionDemarrage',
    ],
  };
};
